<template>
  <div class="emailtemplate">
    <el-dialog
      :show-close="false"
      title=""
      :visible.sync="emailDialogVisible"
      width="80%"
      top="3%"
      :before-close="handleCloseEmail"
      :closeOnPressEscape="false"
      :closeOnClickModal="false"
      center
    >
      <div class="emailcontent flex">
        <div class="list">
          <div class="title">模板列表</div>

          <div class="template">
            <div
              class="item"
              :class="index === activeIndex ? 'choosed' : ''"
              v-for="(item, index) in templatesList"
              :key="index"
              @click="choosedTemplate(item, index)"
            >
              <div>{{ item.name }}</div>
              <div>
                <!-- <i class="el-icon-edit-outline"></i> -->
                <i class="el-icon-delete" @click="deleteTemplate(item.id)"></i>
              </div>
            </div>
          </div>
          <div class="addbtn">
            <el-button
              style="width: 100%"
              plain
              icon="el-icon-plus"
              type="primary"
              @click="addTemplate"
              >添加模板</el-button
            >
          </div>
        </div>
        <div class="emailhtml" :key="activeIndex">
          <div class="top">
            <el-form
              ref="ruleForm"
              :model="form"
              :rules="rules"
              :inline="true"
              :label-position="position"
            >
              <el-row :gutter="20">
                <el-col :span="12"
                  ><el-form-item
                    label="模板名"
                    :label-width="labelWidth"
                    prop="name"
                  >
                    <el-input
                      size="small"
                      v-model="form.name"
                      autocomplete="off"
                    ></el-input> </el-form-item
                ></el-col>
                <el-col :span="12">
                  <el-form-item
                    label="备注"
                    :label-width="labelWidth"
                    prop="remark"
                  >
                    <el-input
                      size="small"
                      v-model="form.remark"
                      autocomplete="off"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="emailDialogVisible">
            <Toolbar
              style="
                border-bottom: 1px solid #e5e5e5;
              "
              :editor="myeditor"
              :defaultConfig="mytoolbarConfig"
              :mode="mymode"
            />
            <Editor
              ref="myEditor"
              style="
                min-height: 200px;
                max-height: 58vh;
                width: 100%;
                overflow-y: scroll;
                background: #fff;
              "
              v-model="templateHtml"
              :defaultConfig="myeditorConfig"
              :mode="mymode"
              @onCreated="onCreated"
              @onChange="onChange"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex butt">
          <el-button
            v-show="canSave || type === 'edit'"
            type="primary"
            style="margin-right: 10px"
            @click="confirmSave('ruleForm')"
            >保存</el-button
          >
          <el-button type="primary" plain @click="gobackTemplate"
            >返回</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  TEMPLATES,
  EMAILTEMPLATE,
  ADDEMAILTEMPLATE,
  UPDATEEMAILTEMPLATE,
  DELETEEMAILTEMPLATE,
} from "@/api/emial";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"; // 引入子组件
import { DomEditor } from "@wangeditor/editor";
export default {
  name: "email",
  components: {
    Editor,
    Toolbar,
  },
  data() {
    return {
      position: "right",
      labelWidth: "100px",
      emailDialogVisible: false,
      myeditor: null,
      mytoolbarConfig: {},
      myeditorConfig: { placeholder: "请输入内容..." },
      mymode: "default",
      templatesList: [],
      templateHtml: "<p></p>",
      activeIndex: null,
      type: "add",
      canSave: false,
      confirmState: false,
      form: {
        name: "",
        content: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
      },
    };
  },
  watch: {
    templateHtml: {
      deep: true,
      handler(val) {
        if (this.myeditor.getText().length > 0) {
          this.canSave = true;
        } else {
          this.canSave = false;
        }
      },
    },
  },

  mounted() {
    this.templateshtml();
  },
  methods: {
    init() {
      this.type = "add";
      this.activeIndex = null;
      this.form = {};
      this.templateHtml = "<p></p>";
      this.templateshtml();
      this.emailDialogVisible = true;
    },
    // 获取邮件模板
    templateshtml() {
      EMAILTEMPLATE({
        currentPage: 1,
        size: 100,
      }).then((res) => {
        this.templatesList = res.data.body.records;
      });
    },
    handleCloseEmail() {
      this.emailDialogVisible = false;
    },
    widthclice(e, d) {
      if (e == 1) {
        this.widthSize = "85.5%";
        this.zkstyts = 2;
        this.widthstuts = 2;
      } else {
        this.widthSize = "45%";
        this.zkstyts = 1;
        this.widthstuts = 1;
      }
    },
    onCreated(editor) {
      this.myeditor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.mytoolbarConfig = {
        excludeKeys: [
          "insertVideo",
          "uploadVideo",
          "group-video",
          "group-image",
          "insertLink",
          "fullScreen",
          "codeBlock",
        ],
      };
    },
    onChange(editor) {
      const toolbar = DomEditor.getToolbar(editor);
    },
    choosedTemplate(item, index) {
      this.type = "edit";
      this.activeIndex = index;
      this.form = {...item};
      this.templateHtml = this.form.content;
    },
    addTemplate() {
      this.type = "add";
      this.activeIndex = null;
      this.form = {};
      this.templateHtml = "<p></p>";
      this.myeditor.focus(true);
    },
    confirmSave(formName) {
      this.form.content = this.templateHtml;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let param = {
              name: this.form.name,
              content: this.form.content,
              remark: this.form.remark,
            };
            ADDEMAILTEMPLATE(param).then((res) => {
              if (res.data.code == "success") {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.init();
              }
            });
          } else if (this.type == "edit") {
            let param = {
              name: this.form.name,
              content: this.form.content,
              remark: this.form.remark,
              id: this.form.id,
            };
            UPDATEEMAILTEMPLATE(param).then((res) => {
              if (res.data.code == "success") {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.init();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteTemplate(id) {
      DELETEEMAILTEMPLATE({ id: id }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.init();
        }
      });
    },
    gobackTemplate() {
      this.emailDialogVisible = false;
      this.$emit("templateBack");
    },
  },
  beforeDestroy() {
    const editor = this.myeditor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style lang="less" scoped>
.emailcontent {
  height: calc(69vh -150px);
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 2px 0px #e1e1e1;
  overflow: hidden;

  .list {
    width: 220px;
    border-right: 1px solid #e5e5e5;
    .title {
      text-align: center;
      padding: 31px 11px;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #e5e5e5;
    }
    .addbtn {
      text-align: center;
      padding: 8px;
      border-top: 1px solid #e1e1e1;
    }

    .template {
      padding: 8px;
      height: calc(100% - 152px);
      max-height: 70vh;
      overflow-y: scroll;

      .item {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        align-items: center;
        // border-bottom: 1px solid #e1e1e1;

        &:hover {
          color: #be3c6e;
          .el-icon-edit-outline {
            opacity: 1;
          }
          .el-icon-delete {
            opacity: 1;
          }
        }

        .el-icon-edit-outline {
          color: #0c0909;
          margin-right: 8px;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;

          &:hover {
            background-color: #d5d5d5;
          }
        }
        .el-icon-delete {
          color: #be3c6e;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;
          &:hover {
            background-color: #d5d5d5;
          }
        }
      }

      .choosed {
        color: #be3c6e;
        border: 1px solid #be3c6e;
      }

      /* 滚动条优化 start */
      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }

      &::-webkit-scrollbar-track {
        background: #f6f6f6;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background: #cdcdcd;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #747474;
      }

      &::-webkit-scrollbar-corner {
        background: #f6f6f6;
      }

      /* 滚动条优化 end */
    }
  }
  .emailhtml {
    flex: 1;
    min-height: 50vh;

    .top {
      padding: 20px 10px 0 10px;
      border-bottom: 1px solid #e5e5e5;
    }
  }
}


::v-deep(.el-form-item) {
  margin-bottom: 20px !important;
}
::v-deep(.el-form-item__content) {
  width: auto !important;
}
</style>
